import { takeEvery } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import {
    ADD_TO_CART,
    addedToCart,
    addToCartError,
    resetAddToCart,
    saveFormValidation
} from '../actions/productActions';

import { makeRequest } from '../../../core/js/sagas/makeRequest';

import { modalShepherdSingleton } from '../../../core/js/components/modalShepherdComponent';

import { buildErrorsFromResponse, GENERAL_ERROR } from '../../../core/js/utils/errorHandling';
import { error } from '../../../core/js/utils/logger';
import { getAddToCartEntity } from '../routes/productAddToCartEntities';
import { getAddToCartRoute } from '../routes/productAddToCartRoutes';
import productUtils from '../utils/utils';
import { isQuickshop } from '../utils/quickshopUtils';
import { getConfirmViewModel } from '../utils/cartConfirmUtils';
import { requestCartItemsSaga } from '@core/js/sagas/cartSagas';

// eslint-disable-next-line consistent-return
function getComponent(action) {
    if (productUtils.actionIsForFamilyProduct(action)) {
        return action.meta.component;
    }
}

function *handleAddedToCartSaga(action, res, confirmViewModel = {}) {
    const component = getComponent(action);

    yield put(addedToCart({
        showConfirm: true,
        confirmViewModel: confirmViewModel,
        isConfirmTimerActive: true,
        quantityRequested: res.quantityRequested
    }, component));
}

function *handleAddtoCartErrorSaga(action, err) {
    error('Unable to Add to Cart', err);

    const errorPrefix = 'ERROR_PRODUCT';
    const errorEntityCode = _.get(err, 'entity.code');
    const errorCode = errorEntityCode ? `${errorPrefix}_${errorEntityCode}` : GENERAL_ERROR;

    // Add prefix to error object
    err.request = {
        errorPrefix: errorPrefix
    };

    const messages = buildErrorsFromResponse(err);
    const component = getComponent(action);

    yield put(addToCartError(errorCode, component));
    yield put(resetAddToCart(component));

    if (err.entity.field_errors) {
        yield put(saveFormValidation({}, messages, {}, component));
    }
}

function *handleQuickshopAddedToCartSaga(action, res, confirmViewModel = {}) {
    const component = getComponent(action);

    yield put(addedToCart({
        showConfirm: false,
        confirmViewModel: confirmViewModel,
        isConfirmTimerActive: false,
        quantityRequested: res.quantityRequested
    }, component));

    const ccEvtData = {
        detail: {
            lineId: res.id
        }
    };

    // dispatch custom event for third party apps i.e. checkout, registry, etc.
    document.dispatchEvent(new CustomEvent('a15-quickshop-success', ccEvtData));

    // For PWA - Set the outcome on the shepherd to be passed through to PWA
    modalShepherdSingleton.outcome = {
        quickshopSuccess: true,
        result: ccEvtData
    };
}

function *handleAddToCartSaga(action) {
    let pwaEvent;
    let state = yield select();
    const product = productUtils.getProductForAction(state, action);
    const entity = getAddToCartEntity(state, product);
    const route = getAddToCartRoute(state, entity);
    const haveClosenessQualifierCookie = _.get(state, 'core.ab.SS_QUALIFIER', '') === 1;

    try {
        const res = yield call(makeRequest, route);
        const confirmViewModel = getConfirmViewModel(state, product, res.quantityRequested);
        const pwaEvtData = {
            detail: _.cloneDeep(confirmViewModel)
        };

        if (isQuickshop(state)) {
            yield handleQuickshopAddedToCartSaga(action, res, confirmViewModel);
            // Do not show bag increment confirmation
            pwaEvtData.detail.bypassConfirmation = true;
        } else {
            if (haveClosenessQualifierCookie) {
                // Call /minicart to check if the most recently added item is eligible for free shipping
                yield call(requestCartItemsSaga);
                _.set(confirmViewModel, 'haveClosenessQualifierCookie', true);
            }
            yield handleAddedToCartSaga(action, res, confirmViewModel);
        }

        pwaEvent = new CustomEvent('a15-item-added-to-cart', pwaEvtData);
        document.dispatchEvent(pwaEvent);

    } catch (err) {
        error('Error adding product to cart');
        yield handleAddtoCartErrorSaga(action, err);
    }
}

export function *addToCartSaga() {
    yield* takeEvery(ADD_TO_CART, handleAddToCartSaga);
}

export default [
    addToCartSaga
];
